/*Footer mobile*/
document.querySelectorAll('.footer__block--links p.h6').forEach(function(el) {
  el.addEventListener('click', function() {
    const list = el.nextElementSibling;

    if (list && list.matches('ul.v-stack')) {
      list.classList.toggle('open');
    }
  });
});

/* showrooms_section */
document.querySelectorAll('.showrooms_section .multi-column .prose p.h3').forEach(function(heading) {
  const section = heading.closest('.showrooms_section');
  if (!section.dataset.baseHeight) {
    section.dataset.baseHeight = section.offsetHeight;
  }
  heading.addEventListener('click', function() {
    const nextP = this.nextElementSibling;
    if (nextP && nextP.tagName.toLowerCase() === 'p') {
      nextP.classList.toggle('open');
      const baseHeight = parseInt(section.dataset.baseHeight);
      const openItems = section.querySelectorAll('.prose p.open');
      if (openItems.length === 1) {
        let extraHeight = 0;
        openItems.forEach(p => extraHeight += p.scrollHeight);
        section.style.minHeight = baseHeight + extraHeight + 'px';
      } 
      else if (openItems.length === 0) {
        section.style.minHeight = baseHeight + 'px';
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 1000) return;
  const slider = document.querySelector('.showrooms_section multi-column.multi-column');
  if (!slider) return;
  const items = slider.querySelectorAll('.multi-column__item');
  if (!items.length) return;
  /* create dots wrapper */
  const dots = document.createElement('div');
  dots.className = 'showroom-dots';
  items.forEach((item, i) => {
    const dot = document.createElement('button');
    dot.className = 'showroom-dot';
    if (i === 0) dot.classList.add('active');
    dot.addEventListener('click', function () {
      slider.scrollTo({
        left: item.offsetLeft,
        behavior: 'smooth'
      });
    });
    dots.appendChild(dot);
  });
  slider.after(dots);
  /* update active dot on scroll */
  slider.addEventListener('scroll', function () {
    const index = Math.round(slider.scrollLeft / items[0].offsetWidth);
    dots.querySelectorAll('.showroom-dot').forEach(d => d.classList.remove('active'));
    if (dots.children[index]) {
      dots.children[index].classList.add('active');
    }
  });
});

/* The swatch-image localStorage cache that used to live here was REMOVED on 2026-08-24.

   It existed only to prop up the old borrowed-artwork filter swatches: those were resolved by scanning
   products on the page, so a colour filtered out of the current view lost its swatch, and this script
   re-applied the URL it had seen on an earlier unfiltered load.

   Colour filter swatches now come from Theme settings > Colour filter swatches, so every load renders
   correctly whether filtered or not and there is nothing left to cache.

   It had to go, not just become redundant: applyFromCache() only bailed out when the current value
   contained "url(", so a theme-setting hex — a linear-gradient(), no "url(" in it — was not protected,
   and the cached product photo was written straight over the top of it. Anyone who had loaded the site
   before the change kept seeing the old borrowed image, from their own localStorage, no matter what the
   server sent. The stale shack-swatch-map-v1 key is now inert: nothing reads or writes it. */

/* Filter accordions: only one open at a time — opening one closes the others; aria-expanded kept in sync with open state.
   Uses capture-phase document listener (toggle doesn't bubble) so it survives the section DOM swap that happens after each filter apply. */
document.addEventListener('toggle', function (event) {
  var details = event.target;
  if (!details || !details.matches || !details.matches('facets-form .accordion-list details')) return;
  details.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  if (!details.open) return;
  var list = details.closest('.accordion-list');
  if (!list) return;
  list.querySelectorAll('details[open]').forEach(function (other) {
    if (other !== details) {
      other.open = false;
      other.setAttribute('aria-expanded', 'false');
    }
  });
}, true);

/* Live update of "Filter Items (N)" button count based on in-progress filter selections */
(function () {
  if (window.__filterItemsCountInit) return;
  window.__filterItemsCountInit = true;

  document.querySelectorAll('facets-form').forEach(function (facetsForm) {
    var form = facetsForm.querySelector('form');
    if (!form) return;
    /* Count badge may live inside facets-form (sidebar) or in the facets-drawer footer slot — search the broader container. */
    var scope = facetsForm.closest('facets-drawer') || facetsForm.closest('.facets-sidebar') || facetsForm;
    if (!scope.querySelector('.filter-items-count')) return;
    var sectionId = facetsForm.getAttribute('section-id');
    var abortController = null;

    facetsForm.addEventListener('change', function () {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      var params = new URLSearchParams(new FormData(form));
      params.set('section_id', sectionId);

      var url = new URL(form.action, location.origin);
      url.search = params.toString();

      fetch(url.toString(), { signal: abortController.signal })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCountEl = doc.querySelector('.filter-items-count');
          if (newCountEl) {
            var count = newCountEl.textContent.trim();
            scope.querySelectorAll('.filter-items-count').forEach(function (el) {
              el.textContent = count;
            });
          }
        })
        .catch(function (e) {
          if (e && e.name !== 'AbortError') console.error('Filter count update failed:', e);
        });
    });
  });
})();

/* Clicking the sidebar "Filter Items" button on desktop should leave the section with all accordions collapsed after the swap.
   We close every open <details> here in capture phase — those toggle events feed theme.js's openDetailsValues set, so by the time
   the section is re-rendered the set is empty and no accordion is reopened. Scoped to .filter-items-button-wrapper submit clicks
   so search-page auto-submit-on-change (no explicit button) is unaffected. */
document.addEventListener('click', function (event) {
  var btn = event.target && event.target.closest && event.target.closest('.filter-items-button-wrapper button[type="submit"]');
  if (!btn) return;
  var form = btn.closest('facets-form');
  form = form && form.querySelector('form');
  if (!form) return;
  form.querySelectorAll('.accordion-list details[open]').forEach(function (d) {
    d.open = false;
  });
}, true);

/* Firefox accepts e/E/+/-/. inside <input type="number"> price fields. Block those keys and sanitize any
   non-digit characters (including pasted content) so only whole-number prices remain. */
(function () {
  function isPriceInput(el) {
    return el && el.matches && el.matches('price-range input[type="number"]');
  }
  var blockedKeys = ['e', 'E', '+', '-', '.', ','];
  document.addEventListener('keydown', function (event) {
    if (!isPriceInput(event.target)) return;
    if (event.ctrlKey || event.metaKey || event.altKey) return;
    if (blockedKeys.indexOf(event.key) !== -1) event.preventDefault();
  }, true);
  document.addEventListener('input', function (event) {
    if (!isPriceInput(event.target)) return;
    var cleaned = event.target.value.replace(/[^0-9]/g, '');
    if (cleaned !== event.target.value) event.target.value = cleaned;
  }, true);
})();

/* Fallback for the price fields sizing to their value, at BOTH breakpoints.
 *
 * custom.css does this with `field-sizing: content`, which Chrome and current Safari support natively —
 * this only runs where they don't (Firefox at time of writing). Without it the field keeps a fixed box
 * that is wider than its value, and the leftover shows up next to the track: after "$0" on desktop and
 * before the track's right edge on mobile (86d3zpw8j).
 *
 * The surrounding label keeps its fixed width on desktop, so sizing the field here cannot change the
 * track's length — the slack simply moves to the outer side of the label.
 */
(function () {
  if (window.CSS && CSS.supports && CSS.supports('field-sizing', 'content')) {
    return;
  }

  function sizeField(el) {
    if (!el || !el.matches || !el.matches('price-range input[type="number"]')) {
      return;
    }
    var len = String(el.value || el.placeholder || '').length || 1;
    // Half a character of slack stops the caret clipping the last digit.
    el.style.width = (len + 0.5) + 'ch';
  }

  function sizeAll(root) {
    (root || document).querySelectorAll('price-range input[type="number"]').forEach(sizeField);
  }

  // Dragging the slider writes to these inputs, so `input` covers the common case.
  document.addEventListener('input', function (event) { sizeField(event.target); }, true);
  document.addEventListener('change', function (event) { sizeField(event.target); }, true);

  // The facets markup is replaced wholesale on every filter change, so re-size whatever comes back.
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var node = records[i].addedNodes[j];
          if (node.nodeType === 1) {
            sizeAll(node);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sizeAll(); });
  } else {
    sizeAll();
  }
})();

/**
 * Review-stars anchor — 86d4a29x4, Jordan 2026-09-08: "Ensure anchor for review stars anchors cleanly
 * to the top of the reviews (see attached)".
 *
 * The stars under the product title are reviews.io's rating snippet, and it is reviews.io's own
 * "anchor_to_reviews_widget" app-embed setting (config/settings_data.json) that makes them clickable.
 * Its scroll ignores the sticky header and undershoots badly. Measured on
 * /products/hamptons-cafe-chair-white-rattan-seat with the page fully settled — document height
 * identical before and after the click, so this is not lazy content growing underneath — the reviews
 * section starts at y=2724 and a clean landing is 2724 - 99 = 2625, but reviews.io scrolls to 2241.
 * 384px short, which drops the "Based on N reviews" heading almost half a screen down the viewport
 * instead of tucking it under the header the way the client's screenshot shows.
 *
 * Rather than try to correct their arithmetic, this takes the click in the CAPTURE phase on document
 * and performs the scroll itself, so their handler never sees the event. document-capture runs before
 * any listener bound to the element, which is the only ordering guarantee available against a
 * third-party script we cannot edit.
 *
 * The scroll is a plain scrollIntoView, which honours `scroll-padding-top` on <html>. theme.css:13
 * ties that to --sticky-area-height, so the section lands exactly under whatever the sticky area
 * currently measures and keeps doing so if the header or announcement bar changes height. Every other
 * in-page anchor on the site already resolves this way, so the landing matches them rather than
 * hardcoding today's 99px.
 *
 * Delegated from document rather than bound to the snippet, because a linked-product swap re-renders
 * it — innerHTML never runs scripts, so anything bound directly would be lost (see
 * assets/linked-products.js reinitReviews(), and [[shack-swap-reinit-pattern]]).
 */
(function () {
  var SNIPPET = '.ruk_rating_snippet';

  function reviewsTarget() {
    var widget = document.querySelector('.reviews-io-polaris-widget, [data-reviewsio-widget]');
    if (!widget) return null;
    // The section, not the widget: the design tucks the section's own cream ground under the header,
    // and the widget sits inside that padding.
    return widget.closest('.shopify-section') || widget;
  }

  function goToReviews(event) {
    var snippet = event.target && event.target.closest && event.target.closest(SNIPPET);
    if (!snippet) return;

    var target = reviewsTarget();
    // No reviews section on this template — leave reviews.io to do whatever it would have done.
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var startY = window.scrollY;

    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

    // Send focus with it, or a keyboard user is scrolled somewhere their tab order has not moved to.
    // preventScroll because scrollIntoView above already owns the scroll position.
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });

    // Smooth scrolling can be suppressed outright — a background tab, a reduced-motion OS setting the
    // media query does not surface, some automation contexts — and when it is, scrollIntoView silently
    // does nothing at all. That is a worse outcome than the undershoot this replaces, so re-assert
    // without animation if the page has not begun to move. If the visitor scrolled by hand in the
    // meantime the position has already changed and this leaves them alone; if they were already at the
    // target it re-lands on the same pixel. Verified against the instant path, which is exact.
    if (!reduced) {
      setTimeout(function () {
        if (Math.abs(window.scrollY - startY) < 2) {
          target.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      }, 300);
    }
  }

  document.addEventListener('click', goToReviews, true);

  // The snippet is a div with role="button", so Enter does not synthesise a click. reviews.io binds its
  // own key handling; intercept the same two keys here so the keyboard path lands in the same place.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    if (!(event.target && event.target.closest && event.target.closest(SNIPPET))) return;
    goToReviews(event);
  }, true);
})();
/* ---------------------------------------------------------------------------------------------
   Search: put the cursor in the box on the FIRST tap (86d4bvuq9)

   Jake: "make the keyboard/type functionality start as soon as clicking on the search icon instead
   of having to click twice."

   Cause, in assets/theme.js:

     initialFocus: matchesMediaQuery("supports-hover") ? this.initialFocus : false

   On a touch device Prestige deliberately passes `false`, so the focus trap focuses nothing and the
   drawer opens with the cursor nowhere. On desktop the same getter resolves to the search input,
   which is why this only shows up on a phone. Compounding it, the trap only activates once the
   200ms enter animation has finished (`checkCanFocusTrap`), and a focus() that far outside the tap
   does not raise the keyboard on iOS even when it does move the cursor.

   So the focus has to happen synchronously, inside the gesture. DialogElement's
   attributeChangedCallback sets `display: block`, re-parents the dialog if it needs to, and only
   then dispatches a bubbling `toggle` event — all in the same task as the click. Listening for that
   is the earliest point at which the input is both present and displayed, and it is still within
   the user gesture, which is what iOS requires.

   Not bound to the toggle button: `toggle` also fires when the drawer closes, and reading the
   `open` attribute off the dialog is more reliable than tracking which control was pressed.

   preventScroll because the drawer is already positioned under a sticky header; letting the browser
   scroll to the input shifts the page underneath the overlay.

   Harmless on desktop — the focus trap would put focus on this same input a moment later.
--------------------------------------------------------------------------------------------- */
(function () {
  document.addEventListener(
    'toggle',
    function (event) {
      var dialog = event.target;
      if (!dialog || typeof dialog.matches !== 'function' || !dialog.matches('header-search')) return;
      if (!dialog.hasAttribute('open')) return;

      var input = dialog.querySelector('.header-search__input');
      if (!input || document.activeElement === input) return;

      try {
        input.focus({ preventScroll: true });
      } catch (e) {
        input.focus();
      }
    },
    true
  );
})();
